import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl, api_service_path } from "./utils"


export const studentAction = createApi({
    reducerPath: "studentApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${baseUrl}/${api_service_path.student}`,
        prepareHeaders: (headers) => {
            const current_user = localStorage.getItem("current_user") ? JSON.parse(localStorage.getItem("current_user")) : null
            if (current_user?.token) {
                headers.set(
                    "Authorization",
                    `Bearer ${current_user.token}`
                )
            }
            return headers
        }
    }),
    tagTypes: ["student"],
    endpoints: (builder) => ({
        getClassStudents: builder.query({
            query: ({
                school_id,
                class_id
            }) => ({
                url: `/get_class_student/${class_id}/${school_id}`,
                method: "GET"
            })
        }),
        deleteStudent:builder.mutation({
            query:({
                school_ref,
                class_ref,
                student_ref
            })=> ({
                url:`/delete-class-student/${school_ref}/${class_ref}/${student_ref}`,
                method:"DELETE",
                body:{
                    school_ref,
                    class_ref,
                    student_ref
                }
            })
        }),
        createClassStudent: builder.mutation({
            query: (data) => ({
                url: "/create",
                method: "POST",
                body: data
            })
        }),
        updateStudentDetails: builder.mutation({
            query: ({
                data,
                student_id
            }) => ({
                url: `/update_student/${student_id}`,
                method: "PUT",
                body: data
            })
        }),
        updateStudentMetadata: builder.mutation({
            query: ({
                user_id,
                meta_data
            }) => ({
                url: `/metadata/${user_id}`,
                method: "PUT",
                body: {
                    meta_data
                }
            })
        }),
        downloadStudentBulkImportTemplate: builder.query({
            query: () => ({
                url: "/student/template",
                method: "GET",
                responseHandler: async (response) => response.blob()
            })
        }),
        bulkImportStudents: builder.mutation({
            query: ({
                school_ref,
                class_ref,
                file
            }) => {
                const formData = new FormData()
                formData.append("file", file)

                return {
                    url: `/bulk-import/${school_ref}/${class_ref}`,
                    method: "POST",
                    body: formData,
                }
            },
        }),
    })
})

export const {
    useLazyGetClassStudentsQuery,
    useCreateClassStudentMutation,
    useUpdateStudentMetadataMutation,
    useUpdateStudentDetailsMutation,
    useLazyDownloadStudentBulkImportTemplateQuery,
    useBulkImportStudentsMutation,

    useDeleteStudentMutation
} = studentAction